import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryByAxios } from "@/redux/api/fetchBaseQueryHelper";
import _ from "lodash";

/**
 * https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#prepareheaders
 * here to learn more about the query
 * or see
 * `postSlice-example`, `userSlice-example`
 */
export const releaseApi = createApi({
	reducerPath: "release",
	baseQuery: fetchBaseQueryByAxios,
	endpoints: (builder) => ({
		getReleaseByDate: builder.query({
			query: (date) => `/release/releaseByDate?release_date=${date}`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
        addRelease: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/release/newRelease",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		updateRelease: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/release/releaseByDate",
					method: "PUT",
					body: initialPost,
				};
			},
		}),

	}),
});

export const {
	useGetReleaseByDateQuery,
    useAddReleaseMutation,
    useUpdateReleaseMutation,
} = releaseApi;
